import { Component, Pipe } from "@angular/core";

@Pipe({
    name: "phone",
    standalone: false
})
export class PhonePipe {
  transform(rawNum) {
    if (rawNum) {
      // Normalize: strip leading +1 or standalone leading 1 from 11-digit numbers
      let digits = rawNum.toString().replace(/\D/g, ''); // keep digits only
      if (digits.length === 11 && digits.charAt(0) === '1') {
        digits = digits.substring(1);
      }

      if (digits.length !== 10) {
        // Fallback: return as-is if not a standard US number
        return rawNum;
      }

      const areaCode = digits.substring(0, 3);
      const middle   = digits.substring(3, 6);
      const last     = digits.substring(6, 10);

      return `+1 (${areaCode}) ${middle}-${last}`;
    } else {
      return '';
    }
  }
}
